import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  Box,
  Typography,
  Button,
  MenuItem,
  Select,
  TextField,
  Stack,
} from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const EnhanceTTPaymentModal = ({
  open,
  onClose,
  onConfirm,
  modeOfPayment,
  handleModeOfPaymentChange,
}) => {
  const [paymentDate, setPaymentDate] = useState(dayjs());
  const [remarks, setRemarks] = useState("");

  const handleConfirm = () => {
    onConfirm({
      modeOfPayment,
      paymentDate: paymentDate.toDate(),
      remarks: remarks.trim(),
    });
    setRemarks("");
    setPaymentDate(dayjs());
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: 500 },
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Typography variant="h6" component="h2" gutterBottom>
          Mark Orders as Paid
        </Typography>

        <Stack spacing={3} mt={2}>
          <Select
            value={modeOfPayment}
            onChange={handleModeOfPaymentChange}
            fullWidth
            displayEmpty
          >
            <MenuItem value="Cash">Cash</MenuItem>
            <MenuItem value="Cheque">Cheque</MenuItem>
            <MenuItem value="Bank Transfer">Bank Transfer</MenuItem>
            <MenuItem value="Credit Card">Credit Card</MenuItem>
            <MenuItem value="Bank Remittance">Bank Remittance</MenuItem>
            <MenuItem value="ERP Payment">ERP Payment</MenuItem>
          </Select>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DesktopDatePicker
              label="Date of Payment"
              value={paymentDate}
              onChange={(newValue) => setPaymentDate(newValue)}
              slotProps={{
                textField: {
                  fullWidth: true,
                  variant: "outlined",
                },
              }}
            />
          </LocalizationProvider>

          <TextField
            label="Remarks (Optional)"
            placeholder="e.g. Cheque #12345, Paid via bank transfer"
            multiline
            rows={3}
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            fullWidth
            variant="outlined"
          />
        </Stack>

        <Box sx={{ mt: 4, display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <Button onClick={onClose} variant="outlined">
            Cancel
          </Button>
          <Button onClick={handleConfirm} variant="contained" color="primary">
            Confirm Payment
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

EnhanceTTPaymentModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  modeOfPayment: PropTypes.string.isRequired,
  handleModeOfPaymentChange: PropTypes.func.isRequired,
};

export default EnhanceTTPaymentModal;